export default {
  path: '/fleet/vehicle-reservation/history',
  name: 'VehicleReservationHistory',
  component: () => import(/* webpackChunkName: "fleet" */ '../views/VehicleReservationHistory.vue')
}
